<template>
  <v-container v-style:paddingLeft="$valueByBreakpoint($finPadding.left)"
               v-style:paddingRight="$valueByBreakpoint($finPadding.right)"
               style="height: 100%"
               class="finAgb d-flex align-center"
               fluid>
    <v-row>
      <template v-if="profile.address === null">
        <v-col cols="12" class="pb-5">
          <h1 :style="`text-align: ${isDialog ? 'left': 'center'} !important;`">Ergänze deine Daten</h1>
        </v-col>
        <v-col cols="11" md="7" class="justify-center mx-auto">
          <v-form @submit.prevent="" v-model="valid">
            <v-row justify="center">
              <v-col cols="12" sm="5" lg="4" :class="$vuetify.breakpoint.xsOnly ? 'pb-0' : ''">
                <v-text-field id="nickname-input"
                              v-model="username"
                              :rules="[ v => !!v || 'Bitte gebe deinen Benutzernamen ein' ]"
                              background-color="white"
                              outlined
                              label="Dein Benutzername"
                              placeholder="Wie dürfen wir dich nennen?"/>
              </v-col>
              <v-col cols="12" sm="5" lg="4"  :class="$vuetify.breakpoint.xsOnly ? 'pt-0' : ''">
                <fin-country-selector class="mb-2 mb-sm-8"
                                      v-model="country"
                                      label="Wohnsitz"/>
              </v-col>
            </v-row>
          </v-form>
        </v-col>
      </template>

      <v-col cols="12">
        <h1 :style="`text-align: ${isDialog ? 'left': 'center'} !important;`">Regulatorische Dokumente</h1>
      </v-col>
      <v-col cols="11" md="7" class="justify-center mx-auto">
        <fin-regulation-document-downloads :alert="alert"
                                           :documents="documentsToAccept"
                                           :is-dialog="isDialog"
                                           protected
                                           v-if="documentsToAccept">
          <template #actions>
            <v-checkbox v-model="acceptCheckbox"
                        :label="documentsToAcceptText"></v-checkbox>
            <v-btn :disabled="acceptDocsEnabled"
                   :loading="loading"
                   dark
                   @click="acceptDocs">
              Akzeptieren
            </v-btn>
          </template>
        </fin-regulation-document-downloads>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import {mapActions, mapGetters, mapState} from 'vuex'
import {finUserAPI} from '@/js/finAPI'
import FinRegulationDocumentDownloads from "@/components/common/DocumentDownloads/RegulationDocumentDownloads"
import FinCountrySelector from "@/components/common/CountrySelector"
import {API, graphqlOperation} from "aws-amplify"
import {updateUserPersonData} from "@/js/finMutations"

export default {
  components: {FinRegulationDocumentDownloads, FinCountrySelector},
  props: {
    isDialog: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      valid: false,
      country: {id: 'DE'},
      acceptCheckbox: false,
      loading: false,
      alert: {
        msg: "Bevor es weiter geht, musst du die folgenden regulatorischen Dokumente bestätigen.",
        icon: "icon-information"
      }
    }
  },
  computed: {
    ...mapState({
      profile: state => state.auth.profile,
      user: state => state.auth.user
    }),
    ...mapGetters('auth', ['profile', 'user', 'userId']),
    documentsToAccept() {
      return this.profile.documentsToAccept
    },
    documentsToAcceptText() {
      const gtb = this.profile.documentsToAccept.find(doc => doc.documentId === 'gtb')
      const bafinDocs = this.profile.documentsToAccept.find(doc => doc.documentId !== 'gtb')
      let docs = "regulatorischen Dokumente"
      if (gtb) {
        if (bafinDocs) {
          docs = "AGB, Datenschutzerklärung und regulatorischen Dokumente"
        } else {
          docs = "AGB und Datenschutzerklärung"
        }
      }
      return "Hiermit bestätige ich, dass ich die o.g. " + docs + " zur Kenntnis genommen habe und akzeptiere."
    },
    username: {
      get() {
        return this.profile.username ? this.profile.username : ""
      },
      set(newVal) {
        this.profile.username = newVal
      }
    },
    acceptDocsEnabled() {
      if (this.profile.address === null) {
        return !this.acceptCheckbox || this.loading || !this.valid
      } else {
        return !this.acceptCheckbox || this.loading
      }
    },
    hasDocuments() {
      return this.documentsToAccept?.length
    },
    redirect() {
      try {
        return this.$route.query.redirect
      } catch (e) {
        return null
      }
    },
  },
  methods: {
    ...mapActions('auth', ['updateUsername']),
    async acceptDocs() {
      this.loading = true
      try {

        if (this.profile.address === null) {
          await API.graphql(graphqlOperation(updateUserPersonData,
            {input: {id: this.userId, address: {country: this.country.id}, username: this.username}}))
          this.profile.address = {street: "", streetNo: "", zipCode: "", city: "", country: this.country.id}
        }

        await finUserAPI.acceptDocs(
          this.documentsToAccept.map(({documentId, isPrivate, version}) => ({documentId, isPrivate, version})))
        this.$store.commit('auth/docsAccepted')
        this.loading = false
        this.alert = {msg: "Du wirst jetzt weitergeleitet...", icon: "mdi-loading mdi-spin"}
        await this.next()
      } catch (e) {
        console.error("Failed to accept Docs", e)
        this.$toasted.global.finToast({
          message: "Es ist ein technischer Fehler aufgetreten. Bitte versuche es später erneut.",
          type: 'error',
          options: {
            action: {
              icon: 'icon-close',
              onClick: (e, toastObject) => {
                toastObject.goAway(0)
              }
            },
          }
        })
        this.loading = false
      }
    },
    async next() {
      console.log("this.redirect", this.redirect)
      const redirect = this.redirect && !this.redirect.includes("code=") ? {path: this.redirect} : {name: "myFinHub"}
      console.log("redirect", redirect)

      // Failed to accept Docs Error: Redirected when going from "/regulations?redirect=%2Fprotected%2FmyFinHub" to "/protected/myFinHub" via a navigation guard.
      // see https://stackoverflow.com/questions/62223195/vue-router-uncaught-in-promise-error-redirected-from-login-to-via-a
      //
      // as the router guards can execute other redirects
      // add .catch(() => {})
      await this.$router.push(redirect).catch(() => {
      })
    },
    mounted() {
      if (!this.hasDocuments) {
        this.next()
      }
    },
  }
}
</script>

<style lang="scss" scoped>


</style>
